import styled from 'styled-components'
import { DisplayLarge, BodySmall, color, spacing, BodyLarge, Title } from '@conserveit/blocks'

export const Container = styled.div`
  padding: ${spacing.extraTight};
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol' !important;
`

export const TipHead = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.default};
  font-family: inherit;
`

export const Left = styled(BodySmall)`
  margin-right: ${spacing.default};
  color: ${color.theme.typography.subdued};
`

export const Right = styled(BodySmall)`
  margin-left: ${spacing.default};
  color: ${color.theme.typography.subdued};
`

export const ValueLabel = styled(Title)`
  color: ${color.theme.typography.subdued};
  font-weight: 700;
  margin-bottom: ${spacing.extraTight};
`

export const Value = styled(DisplayLarge)`
`

export const ValueUnit = styled(BodyLarge)`
`
